import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-icon-user-rank" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "p-icon-user-rank__inner",
      style: _normalizeStyle(_ctx.setStyleObj)
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: "/general/assets/img/common/icon/icon-dummy.png",
          alt: ""
        }, null, -1))
      ], true)
    ], 4)
  ]))
}